import React from 'react'

const AttendanceAbsentIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 18 18'>
      <g id='Attendance-Absent-Icon' transform='translate(1 1)'>
        <path
          id='Path_74'
          data-name='Path 74'
          d='M19,11a8,8,0,1,1-8-8A8,8,0,0,1,19,11Z'
          transform='translate(-3 -3)'
          fill='none'
          stroke='#a7a9ac'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          id='Path_75'
          data-name='Path 75'
          d='M18.3,13.5l-4.8,4.8'
          transform='translate(-7.9 -7.9)'
          fill='none'
          stroke='#f26930'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          id='Path_76'
          data-name='Path 76'
          d='M13.5,13.5l4.8,4.8'
          transform='translate(-7.9 -7.9)'
          fill='none'
          stroke='#f26930'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </g>
    </svg>
  )
}

export default AttendanceAbsentIcon
